import React, {memo} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {handelCloseModalMyOrders} from "../../../../redux/actions/modals/myOrders/modalMyOrders";
import {
    actionChangeLoaderModalInvoice,
    actionChangeSelectOrderModalInvoice,
    actionChangeStatusModalInvoice
} from "../../../../redux/actions/modals/modalInvoice/modalInvoice";
import axios from "axios";
import {BASE_URL, ORDERS_DETAILS_POST} from "../../../../apis";
import qs from "querystring";

const CardMyOrderWithEdit = (props) => {
    const {address, delivery_date, totalPrice, delivery_time, id, factor} = props.data.item;
    const {token} = useSelector(state => state.user);

    const dispatch = useDispatch();
    const handleClickMoreView = () => {
        dispatch(handelCloseModalMyOrders());
        handleGetOrderInApi();
        dispatch(actionChangeStatusModalInvoice(true));
    };

    const handleGetOrderInApi = () => {
        dispatch(actionChangeLoaderModalInvoice(true));
        axios({
            method: 'post',
            url: BASE_URL + ORDERS_DETAILS_POST,
            data: qs.stringify({
                order: id,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if (response.data.status === 'ok') {
                dispatch(actionChangeSelectOrderModalInvoice(response.data));
                dispatch(actionChangeLoaderModalInvoice(false));
            } else {
                dispatch(actionChangeStatusModalInvoice(false));
            }
        });

    };
    return (
        <div className={'base-box-card-my-order'}>
            <div className={'box-card-my-order'}>
                <ul className={'list-data-card-my-order'}>
                    <li>
                        <span>
                            <b>شماره فاکتور</b>
                            <span>{id}</span>
                        </span>
                        <span className={'float-left'}>
                            <Link to={"https://fruitmruit.com/ci/factors/customers/" + factor} target="_blank"
                                  onClick={(event) => {
                                      event.preventDefault();
                                      window.open("https://fruitmruit.com/ci/factors/" + factor)
                                  }}>
                                <span className={'text-success'}>
                                مشاهده صورت حساب
                                </span>
                            </Link>
                        </span>
                    </li>
                    <li>
                        <span>مبلغ سفارش</span>
                        <span className={'float-left'}>
                            <span>{parseInt(totalPrice).toLocaleString()}</span>
                            <span> تومان</span>
                        </span>
                    </li>
                    <li>
                        <span>زمان ثبت سفارش</span>
                        <span className={'float-left'}>{delivery_date}</span>
                    </li>
                    <li>
                        <span>زمان ارسال</span>
                        <span className={'float-left'}>{delivery_time}</span>
                    </li>
                    <li>
                        <span>آدرس : </span>
                        <span>{address}</span>
                    </li>
                </ul>
                <div className={'box-access-card-my-order'}>
                    <Row>
                        <Col xs={12}><Button variant="success" className={'base-btn-green-border'} block
                                             onClick={handleClickMoreView}>مشاهده و تغییر جزییات سفارش</Button></Col>
                    </Row>

                </div>
            </div>
        </div>
    );
};

export default memo(CardMyOrderWithEdit);
